import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  type RouterStateSnapshot,
  type UrlTree,
} from '@angular/router';
import { type IFeature } from '@principle-theorem/feature-flags';
import { findInheritedRouteData } from '@principle-theorem/ng-shared';
import { of, type Observable } from 'rxjs';
import { FeatureFlagsService } from './feature-flags.service';

@Injectable({
  providedIn: 'root',
})
export class FeatureEnabledGuard {
  constructor(private _featureFlags: FeatureFlagsService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    _: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const feature: IFeature | undefined = findInheritedRouteData(
      next,
      'feature'
    );

    if (!feature) {
      return of(true);
    }

    return this._featureFlags.isFeatureEnabled$(feature);
  }
}
